import { Box, styled } from '@mui/material';

const StyWrapperButtonsCta = styled(Box, {
    name: 'StyWrapperButtonsCta',
})({
    display: 'flex',
    width: '80%',
    flexFlow: 'row wrap',
    alignItems: 'center',
    marginTop: '3vh',
    justifyContent: 'flex-end',
    '& button': {
        marginRight: '1vw',
    },
});

export default StyWrapperButtonsCta;
